<template>
  <div id="proposta" v-if="permiteEdicao">
    <v-card flat class="pa-0" max-width="1700">
      <v-tabs v-model="step" :slider-color="stepAtual.completed? 'success' : 'primary'" vertical heigth="90px">
        <div class="d-flex align-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn class="mr-lg-2" color="primary" @click="voltar" v-on="on" small icon><v-icon medium>ph-caret-left</v-icon></v-btn>
            </template>
            <span>{{ $route.query.codigoSimulacao ? 'Voltar para a Simulação' : 'Voltar para a Lista de Propostas' }}</span>
          </v-tooltip>

          <span class="text-subtitle-2 text-lg-h5">Proposta</span>
        </div>

        <v-tab v-for="(item, i) in steppers" :disabled="item.showId > step" :key="i" :style="tabHeight" class="elevation-2 mt-3 mb-1 mx-1">
          <v-row class="text-left" width="100%">
            <v-col class="py-4 px-0 text-caption text-lg-subtitle-1 d-flex align-center justify-space-between" cols="12">
              <span :class="item.completed ? 'success--text' : ''">{{ item.text }}</span>
              <v-icon :color="item.completed ? 'success' : ''" class="ml-2">{{ item.icon }}</v-icon>
            </v-col>
          </v-row>
        </v-tab>

        <v-tabs-items touchless v-model="step">
          <v-tab-item class="tab-item" v-show="item.showId === step" v-for="(item, i) in steppers" :eager="steppers[i].eager" :key="i">
          <core-form ref="form" :submit="submit" v-show="item.showId === step">
            <v-card style="max-width" v-if="loaded" class="px-0 ma-1 ml-2" tile>
              <v-card-text ref="container" :style="height" class="px-0">
                <component v-bind:is="item.component"
                           v-bind="item.attrs"
                           proposta
                           v-model="model"
                           @close="close"
                           ref="itemStep"
                           :isNotaComercial="isNotaComercial"
                           @nextStep="nextStep" />
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="px-3">
                <div class="flex-grow-1"></div>
                <v-btn color="white" @click="backStep" v-if="step !== 0">Voltar</v-btn>
                <v-btn v-if="step === steppers.length - 1" @click="redirecionar" color="primary" data-cy="concluir">
                  Concluir
                </v-btn>
                <v-btn v-else type="submit" color="primary">
                  Continuar
                </v-btn>
              </v-card-actions>
            </v-card>
          </core-form>
        </v-tab-item>
      </v-tabs-items>

      </v-tabs>
    </v-card>
  </div>
  <div v-else>
    <v-alert class="mx-4 my-4" type="warning" text outlined>
      Não é possível editar uma proposta na situação: {{model.SituacaoDescricao}}
    </v-alert>
    <v-btn @click="voltar" class="mx-4" text color="primary">
      <v-icon left>
        ph-arrow-left
      </v-icon>
      Voltar para a lista de propostas
    </v-btn>
  </div>
</template>

<style>
</style>

<script>
import PropostaEditEmitente from './PropostaEditEmitente';
import PropostaEditOperacao from './PropostaEditOperacao.vue';
import PropostaEditCredito from './PropostaEditCredito.vue';
import PropostaEditDocumento from './PropostaEditDocumento.vue';
import PropostaResumo from './PropostaResumo.vue';
import PropostaAvalista from './PropostaAvalista.vue';
import PropostaGarantia from './PropostaGarantia.vue';
import PropostaSubscritor from './PropostaSubscritor.vue';
import SimulacaoResumo from '../simulador/SimulacaoResumo';

export default {
  data () {
    return {
      loaded: false,
      height: '100%',
      tabHeight: '80px',
      show: false,
      permiteEdicao: true,
      model: {
        CodigoSimulacao: '',
        Cliente: {
          PessoaDadosContato: {},
          PessoaEndereco: {},
          PessoaBanco: {},
          PF: {}
        },
        Subscritor: {
          PessoaDadosContato: {},
          PessoaEndereco: {},
          PessoaBanco: {},
        },
        Parcelas: {
          primeiraParcela: {},
          ultimaParcela: {}
        },
      },
      step: 0,
      buttonDisabled: true
    }
  },
  computed: {
    isNotaComercial () {
      return this.$api.Estruturadas.NotasComerciais.includes(this.model.TipoContratoSigla)
    },
    steppers () {
      let list = [
        { id: 0, eager: true, component: PropostaEditEmitente, text: 'Emitente', icon: 'ph-user-list' },
        { id: 1, eager: true, component: PropostaEditOperacao, text: 'Dados da Operação', icon: 'ph-gear-six' },
        { id: 2, eager: true, component: PropostaEditCredito, text: 'Dados do Crédito', icon: 'ph-coins' },
        { id: 3, eager: false, component: SimulacaoResumo, text: 'Resumo da Simulação', icon: 'ph-clipboard-text', hide: this.model.TipoCalculoFluxo !== this.$aux.TipoFluxoEnum.Irregular },
        { id: 4, eager: false, component: PropostaEditDocumento, text: 'Documentos', icon: 'ph-folder' },
        { id: 5, eager: false, component: PropostaGarantia, text: 'Garantias', icon: 'ph-shield-check', hide: this.model.TipoOperacaoCred === 2 },
        { id: 6, eager: false, component: PropostaAvalista, text: 'Participantes', icon: 'ph-note-pencil' },
        { id: 7, eager: false, component: PropostaSubscritor, text: 'Dados do Subscritor', icon: 'mdi-account-multiple-outline', hide: !this.isNotaComercial },
        { id: 8, eager: false, component: PropostaResumo, text: 'Resumo', icon: 'ph-clipboard-text' }
      ]

      list = list.filter(p => !p.hide)
      list.forEach((p, i) => {
        p.showId = i
        p.completed = i < this.step
      })

      return list
    },
    stepAtual () {
      return this.steppers.find((p) => p.showId === this.step);
    }
  },

  methods: {
    submit () {
      const th = this
      if (th.model.Codigo) {
        th.$api.Multiplo.Post('FindRecordProposta', { guidID: th.model.Codigo }).then(function (proposta) {
          if (th.$api.UI.PostLoadData(proposta)) {
            th.permiteEdicao = proposta.Situacao === th.$aux.SituacaoPropostaEnum.EmDigitacao
            th.$set(th.model, 'SituacaoDescricao', proposta.SituacaoDescricao)
            th.verificaSubmit()
          }
        })
      } else {
        th.verificaSubmit()
      }
    },
    verificaSubmit () {
      const th = this
      if (th.permiteEdicao) {
        th.$refs.form[th.step].validate(function () {
          if (th.$refs.itemStep[th.step].submit) {
            th.$refs.itemStep[th.step].submit(() => {
              th.nextStep()
            })
          } else {
            th.nextStep()
          }
        });
      }
    },
    nextStep () {
      const th = this
      if (this.model.HasGarantia === false) {
        this.$api.UI.ShowError(
          'Erro',
          'Não é possivel prosseguir pois não há garantia cadastrada para o produto escolhido.'
        );
      } else {
        th.step += 1
        setTimeout(() => {
          if (th.$refs.itemStep[th.step].load) {
            th.$refs.itemStep[th.step].load()
          }
          th.scrollTop(0, 0, th.$refs.container[th.step])
        }, 200)
      }
    },
    backStep () {
      this.step--
    },
    voltar () {
      if (this.model.CodigoSimulacao) {
        this.$router.push(`/simulacao-edit?codigoSimulacao=${this.model.CodigoSimulacao}`)
      } else {
        this.$router.push('/proposta-list')
      }
    },
    close (acao) {
      const th = this
      th.$set(th, 'model', {
        Cliente: {
          PF: {},
          PessoaDadosContato: {},
          PessoaEndereco: {},
          PessoaBanco: {}
        },
        Parcelas: {
          primeiraParcela: {},
          ultimaParcela: {}
        }
      })

      th.step = 0

      if (acao === 'lista') {
        th.$router.push('/proposta-list')
      } else if (acao === 'novo') {
        th.$router.push('/propostas')
        th.$refs.form.forEach(p => p.reset())
      }
    },
    redirecionar () {
      const th = this
      th.$router.push({ path: '/proposta-list', query: { model: th.model } })
    },
    preencheSubscritor (th, notaComercial) {
      th.$set(th.model, 'CodigoNotaComercial', notaComercial.Codigo)
      th.$set(th.model, 'Subscritor', {
        DocumentoFederal: notaComercial.DocumentoFederal,
        Nome: notaComercial.RazaoSocial,
        PessoaDadosContato: {
          Email: notaComercial.Email,
          TelefoneCelular1: notaComercial.TelefoneCelular,
          TelefoneFixo1: notaComercial.TelefoneResponsavelEmpresa,
        },
        PessoaEndereco: {
          CEP: notaComercial.CEP,
          Logradouro: notaComercial.Logradouro,
          Bairro: notaComercial.Bairro,
          NroLogradouro: notaComercial.NroLogradouro,
          Complemento: notaComercial.Complemento,
          UF: notaComercial.UF,
          Cidade: notaComercial.Cidade,
        },
        RazaoSocialAdmEmpresa: notaComercial.RazaoSocialAdmEmpresa,
        CNPJAdmEmpresa: notaComercial.CNPJAdmEmpresa,
        PessoaBanco: {
          Banco: notaComercial.Banco,
          TipoConta: notaComercial.TipoConta,
          Agencia: notaComercial.Agencia,
          Conta: notaComercial.ContaSubscritor,
        }
      })
    }
  },
  mounted () {
    const th = this
    th.$api.Multiplo.Post('ListaProdutoRedeTipoContrato', {}
    ).then((response) => {
      th.$api.Estruturadas.Produtos = response
    })
    if (th.$route.query.codigoSimulacao) {
      const CodigoSimulacao = th.$route.query.codigoSimulacao
      th.$api.Simulacao.Get(CodigoSimulacao).then(response => {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.$api.UTIL.Functions.SetAllButNull(th, th, 'model', JSON.parse(response.modelJson))
          th.$set(th, 'model', {
            ...th.model,
            Codigo: null,
            CodigoEmpresa: response.codigoEmpresa,
            CodigoOperacao: th.$api.UI.Guid.New(),
            CodigoSimulacao: response.codigo,
            Cliente: {
              ...th.model.Cliente,
              PF: response.pf || {},
              Nome: response.nome,
              DocumentoFederal: response.chave,
              PessoaDadosContato: response.PessoaDadosContato || {},
              PessoaEndereco: response.PessoaEndereco || {},
            },
            QtdeParcelasSolicitado: th.model.Prazo,
            PercJurosMensal: th.model.TxJuros
          })
        }
      })
    } else if (th.$route.query.codigoProposta) {
      const CodigoProposta = th.$route.query.codigoProposta
      th.$api.Multiplo.Post('FindRecordProposta', { guidID: CodigoProposta }).then(function (proposta) {
        if (th.$api.UI.PostLoadData(proposta)) {
          proposta.Cliente = Object.assign(th.model.Cliente, proposta.Cliente)
          th.$api.UTIL.Functions.SetAllButNull(th, th, 'model', proposta)
          th.$set(th.model, 'CodigoOperacao', th.$api.UI.Guid.New())
          th.$set(th.model, 'TipoCalculoFluxo', proposta.VencimentoPersonalizado ? th.$aux.TipoFluxoEnum.Irregular : th.$aux.TipoFluxoEnum.Regular)
          th.$set(th.model, 'Produto', th.$api.Estruturadas.TipoContrato.find(p => p.value === proposta.TipoContratoSigla))
          if (proposta.NotaComercial) th.preencheSubscritor(th, proposta.NotaComercial)
          th.permiteEdicao = proposta.Situacao === th.$aux.SituacaoPropostaEnum.EmDigitacao
          th.$api.Multiplo.Post('FindRecordPessoaDadosContato', { guidID: th.model.Cliente.Codigo }).then(contato => {
            if (th.$api.UI.PostLoadData(contato)) {
              th.$api.UTIL.Functions.SetAllButNull(th, th.model.Cliente, 'PessoaDadosContato', contato)
              th.$set(th.model.Cliente.PessoaDadosContato, 'TelefoneFixo1', th.$api.UI.Format.Telefone(contato.TelefoneFixo1))
              th.$set(th.model.Cliente.PessoaDadosContato, 'TelefoneCelular1', th.$api.UI.Format.Celular(contato.TelefoneCelular1))
            }
          })
          if (th.model.Cliente.TipoPessoa === 1) {
            th.$api.Multiplo.Post('SelectPessoa', { filter: { tipoRegistro: 1, DocumentoCliente: th.model.Cliente.DocumentoFederal } }).then(function (pessoa) {
              if (th.$api.UI.PostLoadData(pessoa)) {
                th.$api.UTIL.Functions.SetAllButNull(th, th.model.Cliente, 'PF', JSON.parse(pessoa.JSON).PF)
              }
            })
          }
          const dtoPessoa = { parameters: [{ name: 'CodigoPessoa', value: th.model.Cliente.Codigo }] }
          th.$api.Multiplo.Post('ListPessoaEndereco', dtoPessoa).then(endereco => {
            if (th.$api.UI.PostLoadData(endereco) && endereco.Data.length > 0) {
              th.$api.UTIL.Functions.SetAllButNull(th, th.model.Cliente, 'PessoaEndereco', endereco.Data[0])
              th.$set(th.model.Cliente.PessoaEndereco, 'CEP', th.$api.UI.Format.Cep(endereco.Data[0].CEP))
            }
          })
          th.$api.Estruturadas.ListPropostaCampoAuxiliar(th, th.model.Codigo)

          const dtoParcelasIrregular = {
            dto: {
              CodigoProposta: th.model.Codigo
            }
          }

          th.$api.Multiplo.Post('BuscarSimulacaoFluxoIrregular', dtoParcelasIrregular).then(async function (response) {
            if (th.$api.UI.PostLoadData(response)) {
              th.$set(th.model, 'DtEmissao', response.PMTIrregular.Resumo.DataContratacao)
              th.$set(th.model, 'Prazo', response.PMTIrregular.Resumo.Parcelas.length)
              th.$set(th.model, 'Parcelas', response.PMTIrregular.Resumo.Parcelas)
            }
          })
        }
      })
    } else {
      th.$set(th.model, 'CodigoOperacao', th.$api.UI.Guid.New())
    }

    if (th.permiteEdicao) {
      const el = document.querySelector('.v-main__wrap')
      const elMin = document.querySelector('#proposta .v-tabs-bar .v-tabs-bar__content')
      th.$set(th, 'tabHeight', `height: ${(el.offsetHeight - 161) * 0.125}px;max-height: 80px;`)
      th.$set(th, 'height', `max-height: ${el.offsetHeight - 145}px;min-height: ${elMin.offsetHeight - 69}px;overflow: auto;`)
    }

    th.loaded = true
  }
};

</script>
